import React from 'react'
import Navbar from '../../Components/Navbar'
import PrototypeHeader from '../../Components/PrototypeHeader'
import Productintro from '../../Components/Productintro'
import Footer from '../../Components/Footer'

const Prototyping = () => {
  return (
    <div>
      <Navbar/>
      <PrototypeHeader/>
      <Productintro/>
      <Footer/>

      
    </div>
  )
}

export default Prototyping
